export const UPDATE_TIMESHEET_MODEL = "UPDATE_TIMESHEET_MODEL";
export const UPDATE_TIMESHEET_LOADING = "UPDATE_TIMESHEET_LOADING";
export const UPDATE_EMPLOYEE_TIMESHEET_STATUS = "UPDATE_EMPLOYEE_TIMESHEET_STATUS";
export const SELECT_TIMESHEET = "SELECT_TIMESHEET";
export const SELECT_TIMESHEET_ROW = "SELECT_TIMESHEET_ROW";
export const SELECT_TIMESHEET_ALL = "SELECT_TIMESHEET_ALL";
export const REMOVE_TIMESHEET_ENTRY = "REMOVE_TIMESHEET_ENTRY";
